import { IStyle, Stack, TextBadgeColor, Theme } from "@bps/fluent-ui";
import {
  ClaimAdjustmentStatus,
  ClaimStatuses,
  ClaimStatusText
} from "@libs/gateways/acc/AccGateway.dtos.ts";
import { AccStore } from "@stores/acc/AccStore.ts";

import {
  ClaimStatusBadgeBaseProps,
  ClaimStatusBadgeProps
} from "./ClaimStatusBadge.types.ts";

export const wrapBadge = (children: JSX.Element, root: IStyle) => (
  <Stack horizontal horizontalAlign="center" styles={{ root }}>
    {children}
  </Stack>
);

export const mapToClaimBadgeProps = (
  props: ClaimStatusBadgeBaseProps,
  theme: Theme,
  acc: AccStore
): ClaimStatusBadgeProps => {
  let displayIcon = false;
  let hasBorder = false;
  let badgeColor = TextBadgeColor.red;
  let iconName = "Message";
  let fontColor;
  let statusText = acc.ref.claimStatuses.keyTextValues.find(
    x => x.key === props.status
  )?.text;

  switch (props.status) {
    case ClaimStatuses.Ready:
      badgeColor = TextBadgeColor.green;
      break;
    case ClaimStatuses.Queued:
      displayIcon = true;
      iconName = "Documentation";
      break;
    case ClaimStatuses.Accepted:
      displayIcon = true;
      iconName = "Accept";
      fontColor = theme.palette.green;
      break;
    case ClaimStatuses.Pending:
      displayIcon = true;
      iconName = "HourGlass";
      break;
    case ClaimStatuses.NotAvailable:
      displayIcon = true;
      iconName = "Warning";
      statusText = props.compactMode
        ? ClaimStatusText.NotAvailableLong
        : ClaimStatusText.NotAvailableShort;
      break;
    case ClaimStatuses.Accredited:
      displayIcon = true;
      iconName = "ContactList";
      break;
    case ClaimStatuses.Held:
    case ClaimStatuses.NotVerified:
      badgeColor = TextBadgeColor.lightGrey;
      hasBorder = true;
      break;
    case ClaimStatuses.Private:
      badgeColor = TextBadgeColor.lightGrey;
      break;
    case "Incomplete":
    case ClaimStatuses.Incomplete:
      badgeColor = TextBadgeColor.yellow;
      statusText = "Incomplete";
      break;
    case undefined:
    case "":
      badgeColor = TextBadgeColor.lightGrey;
      statusText = "Private";
      break;
    default:
      iconName = "CannedChat";
      badgeColor = TextBadgeColor.red;
      break;
  }

  return {
    hasBorder,
    badgeColor,
    displayIcon,
    icon: iconName,
    text: statusText,
    styles: props.styles,
    textColor: fontColor,
    badgeSize: props.badgeSize
  };
};

export const mapToClaimAdjustmentBadgeProps = (
  props: ClaimStatusBadgeBaseProps,
  theme: Theme,
  acc: AccStore
): ClaimStatusBadgeProps => {
  let displayIcon = false;
  let hasBorder = false;
  let badgeColor = TextBadgeColor.red;
  let iconName = "Message";
  let fontColor;
  let statusText = acc.ref.claimAdjustmentStatuses.keyTextValues.find(
    x => x.key === props.status
  )?.text;

  switch (props.status) {
    case ClaimAdjustmentStatus.Ready:
      badgeColor = TextBadgeColor.green;
      break;
    case ClaimAdjustmentStatus.Queued:
      displayIcon = true;
      iconName = "Documentation";
      break;
    case ClaimAdjustmentStatus.Accepted:
      displayIcon = true;
      iconName = "Accept";
      fontColor = theme.palette.green;
      break;
    case ClaimAdjustmentStatus.Partial:
      displayIcon = true;
      iconName = "Accept";
      fontColor = theme.palette.green;
      statusText = "Partial";
      break;
    case ClaimAdjustmentStatus.Pending:
      displayIcon = true;
      iconName = "HourGlass";
      break;
    case ClaimAdjustmentStatus.Error:
    case ClaimAdjustmentStatus.DocumentError:
      hasBorder = true;
      break;
    case ClaimAdjustmentStatus.Incomplete:
      badgeColor = TextBadgeColor.yellow;
      statusText = "Incomplete";
      break;
    default:
      iconName = "CannedChat";
      badgeColor = TextBadgeColor.red;
      break;
  }

  return {
    hasBorder,
    badgeColor,
    displayIcon,
    icon: iconName,
    text: statusText,
    styles: props.styles,
    textColor: fontColor,
    badgeSize: props.badgeSize
  };
};
